export default function(key) {
  // From http://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMetadata.html#object-key-guidelines-safe-characters
  return key && key.replace(/[^0-9a-zA-Z!\-_.*'()]/g, '');
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/helpers/sanitize-s3-key.js
 **/